import React, { useEffect, useState } from 'react'
import { getActualCommissionRevenue } from 'services/Manager';
import { Grid, Dropdown,Dimmer,Loader } from 'semantic-ui-react';
import './ActualCommissionRevenue.less'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,AreaChart,Area } from 'recharts';


const ActualCommissionRevenue = ({ openPanel, filterDataToShowHandler, filterDataToShow, actualRevenueLastMonthsHandler, lastMonths }) => {

    const lastMonthsDropdownData = [
        {
            value: 30,
            text: "30 Days"
        },
        {
            value: 60,
            text: "60 Days"
        },
        {
            value: 90,
            text: "90 Days"
        }
    ]

    const [actualRevenueDataState, setActualRevenueDataState] = useState([]);
    const [currentLastMonthsSelection, setCurrentLastMonthsSelection] = useState({});
    const [dataLoading, setDataLoading] = useState(false);

    useEffect(() => {
        let lastMonthsObj = _.first(_.filter(lastMonthsDropdownData, item => item.value == lastMonths));
        if (lastMonthsObj) {
            setCurrentLastMonthsSelection(lastMonthsObj);
        } else {
            setCurrentLastMonthsSelection(lastMonthsDropdownData[0])
        }
    }, []);

    useEffect(() => {
        if (currentLastMonthsSelection.value) {
            loadData();
        }
    }, [currentLastMonthsSelection.value]);

    const loadData = async () => {
        setDataLoading(true)
        let actualRevenueData = await getActualCommissionRevenue(currentLastMonthsSelection.value);
        if (actualRevenueData.resStatus == 200) {
            setActualRevenueDataState(actualRevenueData.data);
        }
        setDataLoading(false)
    }

    const isSubFilterSelected = (filterName) => {
        if (filterDataToShow == filterName) {
            return true;
        } else {
            return false;
        }
    }

    const subFilterClickHandler = (filterName) => {
        openPanel();
        filterDataToShowHandler(filterName)
    }

    const onLastMonthsChange = (e, data) => {
        setCurrentLastMonthsSelection(_.first(_.filter(lastMonthsDropdownData, item => item.value == data.value)));
        actualRevenueLastMonthsHandler(data.value)
    }

    return (
        <div className={"actual-revenue"}>
            <Grid>
                <Grid.Row className={"heading-row"}>
                    <Grid.Column width={5}>
                        <Dropdown fluid name="lastMonths" key="act-sub-fil-lastmonths"
                            selection
                            options={lastMonthsDropdownData}
                            value={currentLastMonthsSelection.value}
                            text={currentLastMonthsSelection.text}
                            onChange={onLastMonthsChange}
                        ></Dropdown>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <span className={"main-heading"}>{"Lead Fee Revenue"}</span>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className={"content-row"}>
                    <Grid.Column width={16}>
                        {
                        dataLoading ? 
                        <Dimmer {...{
                            active: true
                        }}>
                            <Loader>Loading</Loader>
                        </Dimmer> 
                        :
                        <ResponsiveContainer width="100%" height="100%" >
                            <LineChart
                                className={""}
                                data={actualRevenueDataState}
                                margin={{
                                    top: 0,
                                    right: 5,
                                    left: 5,
                                    bottom: 5,
                                }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis  
                                 hide={true}
                                 />
                                <Tooltip />
                                <Legend verticalAlign="bottom" />
                                <Line  type="monotone" dataKey="Charged" stroke="#056e07" />
                                {/* <Line  type="monotone" dataKey="Commission" stroke="#8884d8" /> */}
                                <Line  type="monotone" dataKey="Refunded" stroke="#990000" /> 
                                <Line  type="monotone" dataKey="Disputed" stroke="#4000ff" /> 
                                <Line  type="monotone" dataKey="Total" stroke="#a18d0d" /> 
                                
                            </LineChart>
                        </ResponsiveContainer>
                        }                  
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className={"sub-filter-row"}>
                    <Grid.Column width={4}>
                        <span className={`sub-filter-text ${isSubFilterSelected("market") ? "selected" : ""}`} onClick={isSubFilterSelected("market") ? () => { } : () => { subFilterClickHandler("market") }}>{"Market"}</span>
                    </Grid.Column>
                    <Grid.Column width={8}>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <span className={`sub-filter-text ${isSubFilterSelected("category") ? "selected" : ""}`} onClick={isSubFilterSelected("category") ? () => { } : () => { subFilterClickHandler("category") }}>{"Category"}</span>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    )
}

export default ActualCommissionRevenue